module.exports = __webpack_public_path__ + "static/pexels-photo-1181244-compressor-2627a239acd9be51835d961fa9e220c1.jpeg";